import { lazy, Suspense } from 'react';
import _ from 'lodash';
import { IWidgetThingsClass } from "../../Utils/IWidgetThingsClass";
import { LazyWidget, IconURIPath } from '../../WidgetsThingsStructs';
import { WidgetDescriptionToPlegmaThing, IWidgetDescription, IWidgetDataValidateResp } from '@UI/Widgets/WidgetStructs';
import { WebThingPort, WebThing } from '@API/WebThing';
import { WebThingPortType } from '@API/WebNodeTypes';
import { Plegma } from '@API/Api';
import { WebNode } from '@API/WebNode';
import { CalendarV2Data, DefaultView } from './CalendarV2Structs';
import { LazyLoadingAnimation } from '@Primitive/Lazy';

const CalendarV2 = lazy(() => import('./CalendarV2Async'));
const CalendarV2Settings = lazy(() => import('./CalendarV2Async').then(module => ({ default: module.CalendarV2Settings })));
// -------------------------------------------------------------------------------------------------------
const enum PortKey {
    Data = 'data',
    PopUp = 'popup'
}
// -------------------------------------------------------------------------------------------------------
export class CalendarV2Widget extends IWidgetThingsClass<CalendarV2Data> {
    Render() {
        return <LazyWidget >
            <CalendarV2 />
        </LazyWidget>
    }
    // ---------------------------------------------------------------------------------------------------
    RenderWidgetSettings(key: string, width: number, height: number) {
        return (
            <Suspense fallback={<LazyLoadingAnimation />}>
                <CalendarV2Settings
                    NodeKey={this.NodeKey}
                    ThingKey={this.ThingKey}
                    width={width}
                    height={height}
                    WidgetData={{ ...this.WidgetData }}
                    WidgetDefaultValues={{ ...this.Description.DefaultValues }}
                    SettingListToolbar={this.Parent?.SettingsListToolbar}
                    onWidgetDataUpdate={data => this.WidgetDataUpdate(data)} />
            </Suspense>
        );
    }
    // ---------------------------------------------------------------------------------------------------
    getPorts() {
        // create thing's ports
        return [
            new WebThingPort({
                Name: 'Data',
                PortKey: PortKey.Data,
                Type: Plegma.ePortType.JsonString,
                ioDirection: Plegma.ioPortDirection.Input,
                State: ''
            }, WebThingPortType.Data, data => this.ValidateValues(PortKey.Data, null)),

            new WebThingPort(
                {
                    Name: 'On Popup Data Change',
                    PortKey: PortKey.PopUp,
                    Type: Plegma.ePortType.JsonString,
                    ioDirection: Plegma.ioPortDirection.Output,
                    State: ''
                },
                WebThingPortType.Trigger)

        ];
    }
    // ---------------------------------------------------------------------------------------------------
    initThing() {
        const ports = this.getPorts();
        const thing = new WebThing(this.WebModule, WidgetDescriptionToPlegmaThing(this.Description), ports);
        this.ThingKey = thing.ThingKey;
    }
    // ---------------------------------------------------------------------------------------------------
    updateThing() {
        const node = WebNode.GetInstanceKey(this.NodeKey);
        const thing = node.GetThing(this.ThingKey);
        thing.Ports = {};

        // update thing's ports
        _.forEach(this.getPorts(), v => thing.AddPort(v));
        node.GetModule(this.WebModuleKey).UpdateThing(thing);
    }
    // ---------------------------------------------------------------------------------------------------
    GetDefaultWidgetData(): CalendarV2Data {
        return CalendarV2Widget.GetDefaultWidgetDataStatic();
    }
    // ---------------------------------------------------------------------------------------------------
    static GetDefaultWidgetDataStatic(): CalendarV2Data {
        return {
            defaultView: DefaultView.Week,
            showPopup: true,
            showCustomPopUp: true,
        };
    }
    // ---------------------------------------------------------------------------------------------------
    static GetWidgetDesc(): IWidgetDescription {
        return {
            MinW: 1,
            MinH: 1,
            Key: 'CalendarV2Widget',
            Type: 'CalendarV2Widget',
            Title: 'Calendar V2',
            Data: CalendarV2Widget.GetDefaultWidgetDataStatic(),
            IconURI: IconURIPath + '/svg/calendar.svg'
        };
    }
    // ---------------------------------------------------------------------------------------------------
    ValidateValues(key: string, value: any): IWidgetDataValidateResp {
        // validation for incoming event
        switch (key) {
            default:
                return { valid: true, errors: '' };
        }
    }
    // ---------------------------------------------------------------------------------------------------
    public GetLocalizationDictionary() {
        let dict = {};
        return dict;
    }
}